import api from "@/services/api/axios-client";
import { useMutation } from "@tanstack/react-query";
import { CreateFeedbackDto } from "generated";

export function useCreateFeedbackMutation() {
  return useMutation({
    mutationFn: (createFeedbackDto: CreateFeedbackDto) => {
      return api.feedbackControllerCreate({ createFeedbackDto });
    },
  });
}
